import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';

@Injectable()
export class ApiServices {

    withCredentials: boolean;

    constructor(private http: Http) {
        this.withCredentials = true;
    }

    serviceCall(url: string, method: string, params: Object, options: Object, header: Object, nocb?: boolean) {
        const httpVerb = method.toLowerCase();
        switch (httpVerb) {
            case 'get':
                return this.getServiceCall(url, params, options, header, nocb);
            case 'post':
                return this.postServiceCall(url, params, options, header);
            case 'put':
                return this.putServiceCall(url, params, options, header);
            case 'delete':
                return this.deleteServiceCall(url, params, options, header);
        }
    }

    private getServiceCall(url: string, params: Object, options: Object, header: Object, nocb?) {

        let headers = new Headers();
        for (let item in header) {
            if (item !== '') {
                headers.append(item, header[item]);
            }
        }

        let parameters = '';
        for (let item in params) {
            if (item !== '') {
                parameters = '&' + parameters + (item + '=' + params[item]);
            }
        }

        if ( !nocb ) {
            url = url.indexOf('?') > 0 ? url + '&cb=' + new Date().getTime() : url + '?cb=' + new Date().getTime();
        }

        url += parameters;

        let opt = new RequestOptions({ headers: headers, withCredentials: this.withCredentials });
        const mergeOptions = opt.merge(options);

        return this.http.get(url, mergeOptions).map(res => res.json());
    }

    private postServiceCall(url: string, params: Object, options: Object, header: Object) {

        let headers = new Headers();
        for (let item in header) {
            if (item !== '') {
                headers.append(item, header[item]);
            }
        }
        let opt = new RequestOptions({ headers: headers, withCredentials: this.withCredentials });
        const mergeOptions = opt.merge(options);

        return this.http.post(url, params, mergeOptions).map(res => res.json());
    }

    private putServiceCall(url: string, params: Object, options: Object, header: Object) {

        let headers = new Headers();
        for (let item in header) {
            if (item !== '') {
                headers.append(item, header[item]);
            }
        }
        let opt = new RequestOptions({ headers: headers, withCredentials: this.withCredentials });
        const mergeOptions = opt.merge(options);

        return this.http.put(url, params, mergeOptions).map(res => res.json());
    }

    private deleteServiceCall(url: string, params: Object, options: Object, header: Object) {

        let headers = new Headers();
        for (let item in header) {
            if (item !== '') {
                headers.append(item, header[item]);
            }
        }
        let opt = new RequestOptions({
            headers: headers, body: params, withCredentials: this.withCredentials
        });
        const mergeOptions = opt.merge(options);

        return this.http.delete(url, mergeOptions).map(res => res.json());
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/services/api.services.ts